import React, { useEffect, useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "../../Css/Contact.css";

const testimonials = [
  {
    title: "Fashion Boutique",
    message:
      "The Munafa software simplified our inventory management. Highly recommended for any retail business.",
    name: "Mike Johnson",
    company: "Restaurant Chain",
    avatar: "M",
  },
  {
    title: "Tech Startup",
    message:
      "Professional team, amazing communication, and delivered beyond our expectations. Best investment for our startup!",
    name: "Priya Patel",
    company: "Tech Startup",
    avatar: "P",
  },
  {
    title: "Retail Store",
    message:
      "EliteNova transformed our business digitally with an amazing website and software system.",
    name: "David Lee",
    company: "Retail Business",
    avatar: "D",
  },
];

const Contact = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // FORM REF
  const form = useRef();

  // AUTO TESTIMONIAL SLIDER
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) =>
        prev === testimonials.length - 1 ? 0 : prev + 1
      );
    }, 3500);

    return () => clearInterval(interval);
  }, []);

  // SEND EMAIL FUNCTION
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_tsfsaft",
        "template_kjy24xs", 
        form.current,
        "ogmvMRj_WZ9UIW322" 
      )
      .then(
        () => {
          alert("Message sent successfully!");
        },
        (error) => {
          console.log(error.text);
          alert("Failed to send message.");
        }
      );

    e.target.reset();
  };

  return (
    <section className="contact-section">
      <div className="contact-glow"></div>

      <div className="contact-container">
        {/* ===== TESTIMONIALS ===== */}
        <div className="testimonial-wrapper">
          <div className="section-badge">
            <span className="badge-dot"></span>
            CLIENT TESTIMONIALS
          </div>

          <h2 className="section-title">
            What Our <span>Clients Say</span>
          </h2>

          {/* SLIDER */}
          <div className="testimonial-slider">
            {testimonials.map((item, index) => (
              <div
                key={index}
                className={`testimonial-card ${
                  index === currentSlide ? "active" : ""
                }`}
              >
                <div className="quote-icon">❝</div>

                <h3>{item.title}</h3>

                <p>"{item.message}"</p>

                <div className="client-info">
                  <div className="client-avatar">
                    {item.avatar}
                  </div>

                  <div>
                    <h4>{item.name}</h4>
                    <span>{item.company}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* DOTS */}
          <div className="slider-dots">
            {testimonials.map((_, index) => (
              <span
                key={index}
                className={`dot ${
                  index === currentSlide ? "active-dot" : ""
                }`}
                onClick={() => setCurrentSlide(index)}
              ></span>
            ))}
          </div>
        </div>

        {/* ===== CONTACT SECTION ===== */}
        <div className="contact-wrapper">
          {/* LEFT */}
          <div className="contact-left">
            <div className="section-badge">
              <span className="badge-dot"></span>
              CONTACT US
            </div>

            <h2 className="section-title">
              Get In <span>Touch</span>
            </h2>

            <p className="contact-description">
              Have a project in mind? We'd love to hear about it.
              Reach out to us and let's build something amazing together.
            </p>

            {/* CONTACT INFO */}
            <div className="contact-info">
              {/* EMAIL */}
              <div className="info-box">
                <div className="info-icon">📧</div>

                <div>
                  <h4>Email us</h4>
                  <p>elitenoova@gmail.com</p>
                </div>
              </div>

              {/* PHONE */}
              <div className="info-box">
                <div className="info-icon">📞</div>

                <div>
                  <h4>Call us</h4>

                  <div className="phone-numbers">
                    <a href="tel:8329254305">
                      8329254305
                    </a>

                    <a href="tel:8983222814">
                      8983222814
                    </a>
                  </div>
                </div>
              </div>

              {/* SOCIAL */}
              <div className="info-box">
                <div className="info-icon">🌐</div>

                <div>
                  <h4>Follow us</h4>
                  <p>Social Media Platforms</p>
                </div>
              </div>
            </div>
          </div>

          {/* ===== FORM ===== */}
          <div className="contact-form-card">
            <form ref={form} onSubmit={sendEmail}>
              {/* NAME */}
              <div className="input-group">
                <label>Name</label>

                <input
                  type="text"
                  name="user_name"
                  placeholder="Your name"
                  required
                />
              </div>

              {/* EMAIL */}
              <div className="input-group">
                <label>Email</label>

                <input
                  type="email"
                  name="user_email"
                  placeholder="your@email.com"
                  required
                />
              </div>
  {/* PHONE */}
  <div className="input-group">
    <label>Phone Number</label>

    <input
      type="tel"
      name="user_phone"
      placeholder="Enter your phone number"
      required
    />
  </div>
              {/* MESSAGE */}
              <div className="input-group">
                <label>Message</label>

                <textarea
                  rows="6"
                  name="message"
                  placeholder="Tell us about your project..."
                  required
                ></textarea>
              </div>

              {/* BUTTON */}
              <button type="submit" className="send-btn">
                Send Message →
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;